import * as constants from './config/constants.js';
import Selectors from './utils/selectors.js';

const selectors = new Selectors();

export default class FormValidator {

    constructor(options = {}) {
        this.matchFields = options.matchFields || '';
        this.errorsSelector = 'data-error-id';
    }

    setup() {
        this.removeMaterialValidation();
        this.setupMaterialTextfieldValidation();
        this.setupMaterialSelectfieldValidation();
        this.materialValidationOnLoad();
        this.forceNumberOnlyFields();
        this.setupMatchFields();
        this.setupRemoveErrorEventListeners();
    }

    matchField(entryField, matchField) {
        if (entryField.value) {
            matchField.setAttribute('pattern', entryField.value);
        }
        entryField.addEventListener('change', () => {
            matchField.setAttribute('pattern', entryField.value);
            matchField.parentNode.MaterialTextfield.checkValidity();
        });
    }

    setupMatchFields() {
        if (this.matchFields) {
            for (let key in this.matchFields) {
                let entryField = document.querySelector(this.matchFields[key]),
                    matchField = document.querySelector(key);
                if (entryField && matchField) {
                    this.matchField(entryField, matchField);
                }
            }
        }
    }

    setupRemoveErrorEventListeners() {
        let errorFields = selectors.querySelectorArray(selectors.attrSelector(this.errorsSelector));
        if (errorFields.length) {
            let self = this;
            errorFields.forEach(function(el) {
                let formElemRow = document.querySelector('#' + el.getAttribute(self.errorsSelector) + '_row');
                if (formElemRow) {
                    let formFields = selectors.querySelectorArray('[name]', formElemRow);
                    if (formFields.length) {
                        formFields.forEach(function(elem) {
                            let removeError = function() {
                                el.parentNode.removeChild(el);
                                elem.removeEventListener('focus', removeError, false);
                            };
                            elem.addEventListener('focus', removeError, false);
                        });
                    }
                }
            });
        }
    }

    removeMaterialValidation() {
        MaterialTextfield.prototype.updateClasses_ = function() {
            if (this.input_) {
                this.checkDisabled();
                this.checkDirty();
                this.checkFocus();
            }
        };
    }

    setupMaterialTextfieldValidation() {
        MaterialTextfield.prototype.CssClasses_.IS_VALID = 'is-valid';
        MaterialSelectfield.prototype.CssClasses_.IS_VALID = 'is-valid';

        MaterialTextfield.prototype.resetValidation = function() {
            this.element_.classList.remove(this.CssClasses_.IS_INVALID);
            this.element_.classList.remove(this.CssClasses_.IS_VALID);
        };

        MaterialTextfield.prototype['resetValidation'] = MaterialTextfield.prototype.resetValidation;

        MaterialTextfield.prototype.checkFocus = function() {
            if (this.element_.querySelector(':focus')) {
                this.element_.classList.add(this.CssClasses_.IS_FOCUSED);
                this.resetValidation();
            } else {
                this.element_.classList.remove(this.CssClasses_.IS_FOCUSED);
            }
        };

        MaterialTextfield.prototype['checkFocus'] = MaterialTextfield.prototype.checkFocus;

        MaterialTextfield.prototype.checkValidity = function() {
            if (!this.input_.value && !this.input_.hasAttribute('required')) {
                return;
            }
            if (this.input_.validity) {
                if (this.input_.validity.valid) {
                    this.element_.classList.remove(this.CssClasses_.IS_INVALID);
                    this.element_.classList.add(this.CssClasses_.IS_VALID);
                } else {
                    this.element_.classList.remove(this.CssClasses_.IS_VALID);
                    this.element_.classList.add(this.CssClasses_.IS_INVALID);
                }
            }
        };

        MaterialTextfield.prototype['checkValidity'] = MaterialTextfield.prototype.checkValidity;

        MaterialTextfield.prototype.validationUpdateClasses_ = function() {
            this.checkValidity();
            MaterialTextfield.prototype.updateClasses_();
        };

        MaterialTextfield.prototype.onBlur_ = function() {
            this.element_.classList.remove(this.CssClasses_.IS_FOCUSED);
            this.validationUpdateClasses_();
        };

        MaterialTextfield.prototype.onFocus_ = function() {
            this.element_.classList.add(this.CssClasses_.IS_FOCUSED);
            this.resetValidation();
        };
    }

    setupMaterialSelectfieldValidation() {
        MaterialSelectfield.prototype.checkValidity = function() {
            if (this.select_.validity) {
                if (this.select_.validity.valid) {
                    this.element_.classList.remove(this.CssClasses_.IS_INVALID);
                    this.element_.classList.add(this.CssClasses_.IS_VALID);
                } else {
                    this.element_.classList.remove(this.CssClasses_.IS_VALID);
                    this.element_.classList.add(this.CssClasses_.IS_INVALID);
                }
            }
        };
    }

    materialValidationOnLoad() {
        window.onload = function() {
            let mdlTextFields = selectors.querySelectorArray('.' + constants.MDL_TEXTFIELD_CLASS);

            if (mdlTextFields.length) {
                mdlTextFields.forEach((el) => {
                    if (el.querySelector('.' + constants.MDL_TEXTFIELD_INPUT_CLASS).value) {
                        el.MaterialTextfield.checkValidity();
                    }
                });
            }
        };
    }

    forceNumberOnlyFields() {
        let numberFields = selectors.querySelectorArray('[type="number"]');
        if (numberFields.length) {
            numberFields.forEach((el) => {
                if (!el.getAttribute('data-force-number')) {
                    el.addEventListener('keypress', (e) => {
                        if (!e.key.match(/[0-9]|Backspace|Delete|Tab|Enter|ArrowLeft|ArrowRight|End|Home|PageDown|PageUp|Clear|Insert/)) {
                            e.preventDefault();
                        }
                    });
                    el.setAttribute('data-force-number', 'true');
                }
            });
        }
    }

}
